
export default function About() {
  return (
    <section id="hakkimizda" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Neden <span className="text-red-600">Yıldırım Reklam</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ankara'da branda ve baskı sektöründe yılların deneyimi ile müşterilerimize en kaliteli hizmeti sunuyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative">
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/cffb6cc42941486dfb4df3eefc3279f0.jpg"
                  alt="Yıldırım Reklam Atölye"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-red-600 text-white p-8 rounded-xl shadow-xl">
                <div className="text-4xl font-bold">15+</div>
                <div className="text-sm">Yıllık Tecrübe</div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Kalite Garantisi</h3>
                  <p className="text-gray-600">
                    En kaliteli malzemeler ve son teknoloji baskı makineleri ile üretim yapıyoruz. Her ürünümüz kalite kontrolünden geçer ve müşteri memnuniyeti odaklı çalışırız.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Profesyonel Ekip</h3>
                  <p className="text-gray-600">
                    Alanında uzman tasarımcı ve üretim ekibimiz ile projelerinizi hayata geçiriyoruz. Müşteri taleplerine özel çözümler üretiyoruz.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Güvenilir Hizmet</h3>
                  <p className="text-gray-600">
                    Zamanında teslimat, şeffaf fiyatlandırma ve satış sonrası destek ile yanınızdayız. Binlerce mutlu müşterimiz bizim referansımızdır.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-fill text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Uygun Fiyatlar</h3>
                  <p className="text-gray-600">
                    Kaliteden ödün vermeden en uygun fiyatlarla hizmet veriyoruz. Toplu siparişlerde özel indirimler sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600 mb-2">5000+</div>
              <div className="text-gray-600 font-medium">Tamamlanan Proje</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600 mb-2">3000+</div>
              <div className="text-gray-600 font-medium">Mutlu Müşteri</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600 mb-2">%100</div>
              <div className="text-gray-600 font-medium">Memnuniyet Oranı</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600 mb-2">24/7</div>
              <div className="text-gray-600 font-medium">Destek Hizmeti</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
